<div class="favorite-tiles w-100">
  <!-- tiles -->
  <div class="row row-cols-2 row-cols-md-3 row-cols-xl-4 g-2">
    @for (fav of pagedFavorites; track trackById($index, fav)) {
      <div class="col">
        <app-tooltip [text]="fav.title" [opensOn]="'Auto'" [position]="'TopCenter'">
          <div class="favorite-card d-flex align-items-center p-2"
            (click)="onFavoriteClick(fav)">
            <app-tooltip [text]="(fav.name ?? '') | translate" [opensOn]="'Auto'" [position]="'TopCenter'">
              @if (fav.icon) {
                <div class="favorite-icon me-2">
                  <app-icon-badge [style]="'default'" [fontSize]="'fs-5'" [class]="fav.color ? 'text-' + fav.color : ''" [icon]="fav.icon"></app-icon-badge>
                </div>
              }
            </app-tooltip>
            <div class="favorite-text flex-grow-1">
              <app-content [fontSize]="'fs-small'"
                [fontColor]="'text-muted'"
                [fontSize]="'fs-default'"
                [fontDecoration]="'fw-bold'"
              class="truncate-text-two-lines">{{ fav.title }}</app-content>
            </div>
          </div>
        </app-tooltip>
      </div>
    }
  </div>

  <!-- pagination -->
  @if (pageCount > 1) {
    <div class="my-3">
      <nav aria-label="FAVORITESPAGINATIONARIALABEL" class="d-flex align-items-center justify-content-center">
        <ul class="pagination pagination-sm justify-content-center mb-0">
          <li class="page-item" [class.disabled]="page <= 1">
            <button
              type="button"
              class="page-link e-prevent-select"
              [disabled]="page <= 1"
              (click)="goToPage(page - 1)">
              {{ 'PREVIOUS' | translate}}
            </button>
          </li>
          <li class="page-item disabled">
            <span class="page-link e-prevent-select">
              {{ page }} / {{ pageCount }}
            </span>
          </li>
          <li class="page-item" [class.disabled]="page >= pageCount">
            <button
              type="button"
              class="page-link e-prevent-select"
              [disabled]="page >= pageCount"
              (click)="goToPage(page + 1)">
              {{ 'NEXT' | translate}}
            </button>
          </li>
        </ul>
      </nav>
    </div>
  }
</div>
